import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Asset from 'modules/assets/pages/Asset';
import Hashtags from 'modules/hashtags/pages/Hashtags';
import Help from 'modules/app/components/Help';
import Playlist from 'modules/playlists/components/Playlist';
import ProfileEditNew from 'modules/profile/pages/ProfileEdit/ProfileEditNew';
import Reports from 'modules/post/components/Reports';
import Post from 'modules/post/components/Post';
import UserVideos from 'modules/profile/components/UserVideos';
import NotFound from 'modules/app/components/NotFound';
import LikedPage from 'modules/profile/pages/Profile/LikedPage';
import CommentedPage from 'modules/profile/pages/Profile/CommentedPage';
import TradingPage from 'modules/trading/pages/TradingPage';
import { Search, View } from 'modules/search/pages/Search';
import FeedByIdPage from 'modules/feed/components/FeedById/FeedById';
import FeedGrid from 'modules/feed/components/FeedGrid/FeedGrid';
import Experts from 'modules/experts/Experts';
import PopularStocks from 'modules/discovery/components/PopularStocks';
import PlaylistMostLiked from 'modules/playlists/components/PlaylistMostLiked';
import HashtagPage from 'modules/hashtags/pages/Hashtag/Hashtag';
import HashtagsPage from 'modules/hashtags/pages/Hashtags/Hashtags';
import Topics from 'modules/discovery/components/Topics';
import TradingList from 'modules/discovery/components/TradingList';
import PasswordReset from 'modules/auth/components/PasswordReset';
import Redirect from 'modules/app/components/Redirect';
import PolicyPage from 'modules/app/components/PolicyPage';
import TermsOfService from 'modules/app/components/PolicyPage/TermsOfService';
import PrivacyPolicy from 'modules/app/components/PolicyPage/PlivacyPolicy';
import CreatePost from 'modules/post/pages/CreatePost';
import Feed from 'modules/feed/components/Feed';
import Home from 'modules/discovery/pages/Home';
import CategoriesPage from 'modules/discovery/pages/Home/Categories/CategoriesPage';
import Profile from 'modules/profile/pages/Profile';
import Loader from 'components/shared/Loader/Loader';
import ScrollToTop from 'modules/app/components/ScrollToTop';
import useIsAuth from 'sdk/hooks/useIsAuth';
import Events from 'modules/events/pages';
import Onboarding from 'modules/onboarding/components/Onboarding';
import SalonProfile from 'modules/salon/pages';
import Venues from 'modules/venues/pages';
import Shop from 'modules/shop/pages';
import RedirectionPage from 'modules/shop/pages/RedirectionPage';
import Product from 'modules/salon/pages/Services/Products/Product';
import ShoppingCart from 'modules/shop/pages/ShoppingCart';
import BookingSuccess from 'modules/feed/components/Feed/Post/AppointmentBooking/BookingSuccess';
import SalonFilterPage from 'modules/salon/pages/SalonFilterPage/SalonFilterPage';
import SalonDetails from 'modules/product/pages/SalonDetails';
import Notification from 'components/shared/Notification';
import AllSpecialists from 'modules/salon/pages/AllSpecialists/AllSpecialists';
import AddReview from 'modules/salon/pages/AddReview';
import AllServices from 'modules/salon/pages/AllServices/AllServices';
import AllProducts from 'modules/salon/pages/AllProducts/AllProducts';
import AllPostedVideos from 'modules/salon/pages/AllPostedVideos/AllPostedVideos';
import OrderDetails from 'modules/product/pages/OrderDetails';
import ProductsByCategory from 'modules/shop/pages/ProductsByCategory/ProductsByCategory';
import UserNotifications from 'modules/notifications/UserNotifications/UserNotifications';
import SendBird from 'modules/chat';
import AllProductsShop from 'modules/shop/pages/AllProductsShop/AllProductsShop';
import AllBrands from 'modules/shop/pages/Brands/AllBrands';
import ProfileFollowing from 'modules/profile/pages/Profile/ProfileTop/ProfileFollowing';
import ReturnStatus from 'modules/app/components/ReturnStatus';
import PassResetByEmail from 'modules/auth/PassResetByEmail';
import NewPass from 'modules/auth/NewPass';
import AddProductReview from 'modules/product/pages/AddProductReview';
import ProfileMenu from 'modules/app/components/ProfileMenu';
import Purchases from 'modules/app/components/ProfileMenu/Pruchases';
import BrandItemsPage from 'modules/shop/pages/Brands/BrandItemsPage';
import AppointmentBooking from 'modules/feed/components/Feed/Post/AppointmentBooking/AppointmentBooking';
import AppointmentBookingSpec from 'modules/feed/components/Feed/Post/AppointmentBookingSpec/AppointmentBookingSpec';
import SignUpNew from 'modules/auth/components/SignUp/New/SignUpNew';
import SignIn from 'modules/auth/components/SignIn';
import AppointmentBookingBundle from 'modules/feed/components/Feed/Post/AppointmentBookingBundle/AppointmentBookingBundle';
import InvoicePreview from 'modules/feed/components/Feed/Post/AppointmentBooking/BookingCheckout/InvoicePreview';
import SuccessfulPayment from 'modules/shop/pages/SuccessfulPayment/SuccessfulPayment';
import AllStores from './modules/shop/pages/Stores/AllStores';
import StoreProfile from './modules/shop/pages/Stores/StoreProfile/StoreProfile';
import BuyedVoucher from 'modules/salon/pages/Services/Vouchers/steps/BuyedVoucher';

export default function AppRoutes() {
  const { data: isAuthData, isLoading: isInitialLoading } = useIsAuth();
  const isAuth = isAuthData?.isAuth;

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Feed />} />
        <Route path="/feed" element={<Feed />} />
        <Route path="/feed/:id" element={<Feed />} />
        <Route path="/feed/playlist/:playlistName" element={<Feed />} />
        <Route path="/user/feed/:feedName/:feedId" element={<Feed />} />
        <Route path="/user/feed/:feedName/:feedId/:id" element={<Feed />} />
        <Route path="/user/grid/:feedName/:feedId" element={<FeedGrid />} />
        <Route path="/search/feed/:id" element={<FeedByIdPage />} />
        <Route path="/search" element={<Search activeLink="/search" view={View.Trending} />} />
        <Route
          path="/search/videos"
          element={<Search activeLink="/search/videos" view={View.Videos} />}
        />
        <Route
          path="/search/assets"
          element={<Search activeLink="/search/assets" view={View.Assets} />}
        />
        <Route
          path="/search/hashtags"
          element={<Search activeLink="/search/hashtags" view={View.Hashtags} />}
        />
        <Route
          path="/search/experts"
          element={<Search activeLink="/search/experts" view={View.Experts} />}
        />
        <Route
          path="/search/experts/:query"
          element={<Search activeLink="/search/experts" view={View.Experts} />}
        />
        <Route
          path="/search/:query"
          element={<Search activeLink="/search" view={View.Trending} />}
        />
        <Route
          path="/search/videos/:query"
          element={<Search activeLink="/search/videos" view={View.Videos} />}
        />
        <Route
          path="/search/assets/:query"
          element={<Search activeLink="/search/assets" view={View.Assets} />}
        />
        <Route
          path="/search/hashtags/:query"
          element={<Search activeLink="/search/hashtags" view={View.Hashtags} />}
        />
        <Route
          path="/termsUse"
          element={
            <PolicyPage title="Terms & Conditions">
              <TermsOfService />
            </PolicyPage>
          }
        />
        <Route
          path="/privacyPolicy"
          element={
            <PolicyPage title="Privacy Policy">
              <PrivacyPolicy />
            </PolicyPage>
          }
        />
        {/*<Route path="/home" element={<Home />} />*/}
        <Route path="/asset/:id" element={<Asset />} />
        <Route path="/asset/:category/:name" element={<Asset />} />
        <Route path="/profile/:id" element={<Profile />} />
        <Route path="/playlist/:name" element={<Playlist />} />
        <Route path="/playlist/most-liked" element={<PlaylistMostLiked />} />
        <Route path="/experts" element={<Experts />} />
        <Route path="/events" element={<Events activeLink="/events" />} />
        <Route path="/events/earnings" element={<Events activeLink="/events/earnings" />} />
        <Route path="/events/stock-splits" element={<Events activeLink="/events/stock-splits" />} />
        <Route path="/events/ipos" element={<Events activeLink="/events/ipos" />} />
        <Route
          path="/events/economic-events"
          element={<Events activeLink="/events/economic-events" />}
        />
        <Route path="/hashtags" element={<HashtagsPage />} />
        <Route path="/hashtags/:id" element={<HashtagPage />} />
        <Route path="/popular-stocks" element={<PopularStocks />} />
        <Route path="/hashtags" element={<Hashtags />} />
        <Route path="/topics" element={<Topics />} />
        <Route path="/category/:id" element={<CategoriesPage />} />
        <Route path="/tradingPlatforms" element={<TradingPage />} />
        <Route path="/tradingPlatforms/:id" element={<TradingPage />} />
        <Route path="/tradingList" element={<TradingList />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/password-reset/email" element={<PassResetByEmail />} />
        <Route path="/password-reset/new-pass" element={<NewPass />} />
        <Route path="/venues" element={<Venues />} />
        <Route path="/redirect" element={<RedirectionPage />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/salon/:id" element={<SalonProfile />} />
        <Route path="/salon/:id/add-review" element={<AddReview />} />
        <Route path="/salon/:id/specialists" element={<AllSpecialists />} />
        <Route path="/salon/:id/services" element={<AllServices />} />
        <Route path="/salon/:id/products" element={<AllProducts />} />
        <Route path="/salon/:id/videos" element={<AllPostedVideos />} />
        <Route path="/product/:id" element={<Product />} />
        <Route path="/store-profile/:id" element={<StoreProfile />} />
        <Route path="/salon-details/:id" element={<SalonDetails />} />
        <Route path="/voucher/:id" element={<BuyedVoucher />} />
        <Route
          path="/cart"
          element={
            <ShoppingCart open={false} setOpenShoppingCartMenu={() => window.history.go(-1)} />
          }
        />
        <Route path="/booking/:id" element={<BookingSuccess />} />
        <Route path="/salon-filter" element={<SalonFilterPage />} />
        <Route path="/notifications" element={<Notification />} />
        <Route path="/add-product-review/:id" element={<AddProductReview />} />
        <Route path="/profile/edit" element={<ProfileEditNew />} />
        <Route path="/profile/following" element={<ProfileFollowing />} />
        <Route path="/order/:id/:productId" element={<OrderDetails />} />
        <Route path="/products-by-category/:id" element={<ProductsByCategory />} />
        <Route path="/user-notifications" element={<UserNotifications />} />
        <Route path="/help" element={<SendBird />} />
        <Route path="/all-products-shop/:category?" element={<AllProductsShop />} />
        <Route path="/all-brands" element={<AllBrands />} />
        <Route path="/all-stores" element={<AllStores />} />
        <Route path="/brand-items/:id" element={<BrandItemsPage />} />
        <Route path="/return-status/:id" element={<ReturnStatus />} />

        <Route path="/successful_payment" element={<SuccessfulPayment />} />

        <Route
          path="/appointment-booking/:salonId"
          element={
            !isInitialLoading ? (
              isAuth ? (
                <AppointmentBooking />
              ) : (
                <Navigate to="/sign-up" />
              )
            ) : (
              <Loader />
            )
          }
        />
        <Route path="/invoice-preview" element={<InvoicePreview />} />

        <Route
          path="/appointment-booking-spec/salon/:salonId/specialist/:specialistId"
          element={
            !isInitialLoading ? (
              isAuth ? (
                <AppointmentBookingSpec />
              ) : (
                <Navigate to="/sign-up" />
              )
            ) : (
              <Loader />
            )
          }
        />
        <Route
          path="/appointment-booking-spec/salon/:salonId/bundle/:bundleId"
          element={
            !isInitialLoading ? (
              isAuth ? (
                <AppointmentBookingBundle />
              ) : (
                <Navigate to="/sign-up" />
              )
            ) : (
              <Loader />
            )
          }
        />

        <Route path="/sign-up" element={<SignUpNew />} />
        <Route path="/sign-in" element={<SignIn />} />

        {isAuth && !isInitialLoading ? (
          <>
            <Route path="/reports" element={<Reports />} />
            <Route path="/create/post" element={<CreatePost />} />
            <Route path="/post/:id" element={<Post />} />
            <Route path="/help" element={<Help />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile-menu" element={<ProfileMenu />} />
            <Route path="/profile-menu/purchases" element={<Purchases />} />

            <Route path="/user-videos/:id" element={<UserVideos />} />
            <Route path="/liked/:id" element={<LikedPage />} />
            <Route path="/commented/:id" element={<CommentedPage />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/redirect" element={<Redirect />} />
          </>
        ) : null}
        {isInitialLoading ? (
          <Route path="*" element={<Loader />} />
        ) : (
          !isAuth && <Route path="*" element={<NotFound />} />
        )}
      </Routes>
    </Router>
  );
}
